module.exports = __webpack_public_path__ + "img/choice_port1.6bc0b5b9.png";